@if (canvasData) {
  <div
    class="diagram-container"
    [class.panning]="isPanning"
    (contextmenu)="onContextMenu($event)"
    (dblclick)="onDoubleClick($event)"
  >
    <ng-diagram
      [config]="diagramConfig"
      [model]="model"
      [nodeTemplateMap]="nodeTemplates"
      (diagramInit)="onDiagramInit()"
    >
      <ng-diagram-background />
    </ng-diagram>

    <div class="minimap-panel-container">
      <canvas-minimap-panel />
    </div>
  </div>
} @else {
  <canvas-placeholder />
}

<!-- Diagram context menu -->
<div
  #diagramMenuTrigger="matMenuTrigger"
  class="context-menu-trigger"
  [matMenuTriggerFor]="diagramContextMenu"
  [style.left.px]="contextMenuPosition.x"
  [style.top.px]="contextMenuPosition.y"
></div>
<mat-menu #diagramContextMenu="matMenu" class="canvas-context-menu">
  <!-- <button mat-menu-item (click)="onAddNode()">
    <mat-icon>add</mat-icon>
    <span>Add Node</span>
  </button> -->
  <!-- <button mat-menu-item (click)="onZoomToFit()">
    <mat-icon>fit_screen</mat-icon>
    <span>Zoom to Fit</span>
  </button>
  <button mat-menu-item (click)="onResetView()">
    <mat-icon>center_focus_strong</mat-icon>
    <span>Reset View</span>
  </button>
  <mat-divider></mat-divider>-->
  <button mat-menu-item (click)="onSelectAll()">
    <mat-icon>select_all</mat-icon>
    <span>Select All</span>
  </button>
</mat-menu>

<!-- Node context menu -->
<div
  #nodeMenuTrigger="matMenuTrigger"
  class="context-menu-trigger"
  [matMenuTriggerFor]="nodeContextMenu"
  [style.left.px]="contextMenuPosition.x"
  [style.top.px]="contextMenuPosition.y"
></div>
<mat-menu #nodeContextMenu="matMenu" class="canvas-context-menu">
  <button mat-menu-item [disabled]="!canShowNode" (click)="onShowNode()">
    <mat-icon>visibility</mat-icon>
    <span>Show</span>
  </button>
  <button mat-menu-item [disabled]="!canConfigureNode" (click)="onConfigureNode()">
    <mat-icon>settings</mat-icon>
    <span>Configure</span>
  </button>
</mat-menu>
